import React,{FC} from 'react';
import MgpIcon from '../MgpIcon/MgpIcon';
import { MgpButtonProps } from './MgpButton.types';



export default function MgpButton ({ variant, text, color, size, icon, loading, ...props }: MgpButtonProps) {
    if(!color) {
        color = "bleu";
    }
    let btnClassName;
    if(variant && variant === "inline") {
      btnClassName = "cta-inline cta-inline-" + color + (size == "small" ? " cta-small":"") + ( icon? " withicon":"");
    } else {
      btnClassName = "cta-" + color + (size == "small" ? " cta-small":"") + ( icon? " withicon":"");
    }
     
    return (
      <>
      <button className={btnClassName} {...props}>
        {icon ? <MgpIcon icon={icon}/>:""}
        {props.children?props.children:text}
        {loading&&<span className='mgp-spinner'></span>}
      </button>
      
      </>
    );
  };
